function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M72.801 45.5c-1.3 0-2.3 1-2.3 2.3s1 2.302 2.3 2.302 2.3-1 2.3-2.301c-.1-1.301-1.1-2.301-2.3-2.301zM50 5C25.102 5 5 25.102 5 50s20.102 45 45 45 45-20.102 45-45S74.898 5 50 5zm15.301 26.199h-9.602v-9.602zM51.199 19.398v14c0 1.3 1 2.3 2.3 2.3h14.103v3H31.899v-19.3zM68.101 76.8H32.398V55.999h35.699zm9.098-9.7c0 1.302-1 2.302-2.2 2.302h-2.5V56c0-2.5-2-4.5-4.5-4.5H32.398c-2.5 0-4.5 2-4.5 4.5v13.3h-2.399c-1.3 0-2.3-1-2.3-2.3V44.8c0-1.3 1-2.198 2.3-2.198H75c1.3 0 2.2 1 2.2 2.199zm-38.7-5.8V65H62v-3.7zm0 5.8v3.602l23.5-.004v-3.601z"
});

function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.e011a24a.svg";
export { ForwardRef as ReactComponent };